import React from "react";

const DownloadIconBig = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="28.123"
      height="28.07"
      viewBox="0 0 28.123 28.07"
    >
      <g id="downld_ic" transform="translate(-41.2 -41.5)">
        <path
          id="Path_1254"
          data-name="Path 1254"
          d="M69.323,258.437v6.225a1.417,1.417,0,0,1-.044.345h0a1.337,1.337,0,0,1-1.3,1.071H42.537a1.332,1.332,0,0,1-1.319-1.187,1.049,1.049,0,0,1-.018-.239v-6.225a1.328,1.328,0,0,1,2.656,0v4.985H66.676v-4.985a1.327,1.327,0,0,1,2.267-.939A1.4,1.4,0,0,1,69.323,258.437Z"
          transform="translate(0 -196.509)"
        />
        <path
          id="Path_1255"
          data-name="Path 1255"
          d="M124.262,55.694l-6.526,6.526c-.009.018-.027.027-.035.035a1.538,1.538,0,0,1-.859.434c-.027,0-.053.009-.08.009a.962.962,0,0,1-.159.009h0l-.151-.009c-.027,0-.053-.009-.08-.009a1.51,1.51,0,0,1-.859-.434l-.035-.035-6.526-6.526a1.553,1.553,0,0,1,2.2-2.2l3.923,3.923V43.05a1.557,1.557,0,0,1,1.55-1.55,1.584,1.584,0,0,1,1.1.452,1.531,1.531,0,0,1,.452,1.1V57.421l3.923-3.923a1.561,1.561,0,0,1,2.2,0A1.586,1.586,0,0,1,124.262,55.694Z"
          transform="translate(-61.341)"
        />
      </g>
    </svg>
  );
};

export default DownloadIconBig;
